var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisputeCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10754_27439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99998 4.25012H8.99998L8.74998 9.25024H7.24998L6.99998 4.25012Z",
    fill: "#A1150C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24998 10.2502H8.74998V11.7502H7.24998V10.2502Z",
    fill: "#A1150C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85003 0.476334C7.48514 -0.158779 8.51486 -0.158777 9.14997 0.476335L15.5237 6.85003C16.1588 7.48514 16.1588 8.51486 15.5237 9.14997L9.14997 15.5237C8.51486 16.1588 7.48514 16.1588 6.85003 15.5237L0.476334 9.14997C-0.158779 8.51486 -0.158777 7.48514 0.476335 6.85003L6.85003 0.476334ZM8.08931 1.537L14.463 7.91069C14.5123 7.96001 14.5123 8.03998 14.463 8.08931L8.08931 14.463C8.03999 14.5123 7.96002 14.5123 7.91069 14.463L1.53699 8.08931C1.48767 8.03999 1.48767 7.96001 1.537 7.91069L7.91069 1.53699C7.96001 1.48767 8.03998 1.48767 8.08931 1.537Z",
    fill: "#A1150C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10754_27439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisputeCall);
export default __webpack_public_path__ + "static/media/dispute-call.9d748c6c46cd26d09d07e95e6f8abdf2.svg";
export { ForwardRef as ReactComponent };